import R from 'ramda';
import convertToWebp from '@cotyorg/ccx-utils/js/helpers/convert-to-webp';

export const buildImageSrc = ({ item }) =>
  convertToWebp({ src: R.prop('image_xs')(item) });

export const buildImageSrcSet = ({ item }) =>
  [
    {
      name: 'small',
      src: convertToWebp({ src: R.prop('image_sm')(item) }),
    },
    {
      name: 'medium',
      src: convertToWebp({ src: R.prop('image_md')(item) }),
    },
    {
      name: 'large',
      src: convertToWebp({ src: R.prop('image_lg')(item) }),
    },
    {
      name: 'xlarge',
      src: convertToWebp({ src: R.prop('image_xl')(item) }),
    },
  ].filter(({ src }) => src);

export const matchImageWithBreakpoint = ({ currentBreakpoint, image }) =>
  R.or(
    R.path(
      [0, 'src'],
      R.filter(
        R.propEq('name', currentBreakpoint),
        R.propOr({ imageSrcSet: [] }, 'imageSrcSet', image),
      ),
    ),
    R.prop('imageSrc', image),
  );
